import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { colors } from '../../styles/theme.js';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import BarChartIcon from '@mui/icons-material/BarChart';
import CategoryIcon from '@mui/icons-material/Category';
import ChecklistIcon from '@mui/icons-material/Checklist';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const tabs = [
  { label: 'Templates', path: '/config-plus/templates', icon: <ViewQuiltIcon /> },
  { label: 'Kategorien', path: '/config-plus/categories', icon: <CategoryIcon /> },
  { label: 'Scoring Engine', path: '/config-plus/scoring-engine', icon: <BarChartIcon /> },
  { label: 'Check Library', path: '/config-plus/check-library', icon: <ChecklistIcon /> },
  { label: 'Alias Registry', path: '/config-plus/alias-registry', icon: <SwapHorizIcon /> },
];

export default function ConfigPlusLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = tabs.findIndex((t) => location.pathname.startsWith(t.path));

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
        Konfiguration
        <Box component="span" sx={{ color: colors.lime }}>+</Box>
      </Typography>

      <Tabs
        value={currentTab === -1 ? 0 : currentTab}
        onChange={(_, idx) => navigate(tabs[idx].path)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 4,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            color: colors.black85,
            fontWeight: 500,
            '&.Mui-selected': {
              bgcolor: colors.black,
              color: colors.lime,
              borderRadius: '8px 8px 0 0',
              fontWeight: 600,
            },
          },
          '& .MuiTabs-indicator': { bgcolor: colors.lime },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} icon={tab.icon} iconPosition="start" label={tab.label} />
        ))}
      </Tabs>

      <Outlet />
    </Box>
  );
}
